
    import Component from 'vue-class-component';
    import { Prop } from 'vue-property-decorator';
    import { shapes } from '@clientio/rappid';

    import { BaseInspector } from 'src/components/Chatbot/Inspector//Base-inspector/base-inspector';
    interface InspectorPort {
        id: string;
        label: string;
    }
    @Component({})
    export default class MessageInspector extends BaseInspector {
        @Prop() cell: shapes.app.Message;
        public label = '';
        public description = '';
        public icon = '';
        public ports = [] as InspectorPort[];
        public canAddPort = false;
        public props = {
            label: ['attrs', 'label', 'text'],
            description: ['attrs', 'description', 'text'],
            icon: ['attrs', 'icon', 'xlinkHref'],
            portLabel: ['attrs', 'portLabel', 'text']
        }
        public addCellPort(): void {
            this.cell.addDefaultPort();
            this.assignFormPorts();
        }
        public removeCellPort(portId: string): void {
            this.cell.removePort(portId);
            this.assignFormPorts();
        }
        public changeCellPort(port: InspectorPort): void {
            const { cell, props } = this;
            cell.portProp(port.id, props.portLabel, port.label);
        }
        protected assignFormFields(): void {
            const { cell, props } = this;
            this.label = cell.prop(props.label);
            this.description = cell.prop(props.description);
            this.icon = cell.prop(props.icon);
            this.assignFormPorts();
        }
        private assignFormPorts(): void {
            const { cell, props } = this;
            this.canAddPort = cell.canAddPort('out');
            this.ports = cell.getGroupPorts('out').map(({ id }) => {
                return {
                    id,
                    label: cell.portProp(id, props.portLabel)
                }
            });
        }
    }
